import { Match, onMount, Switch } from "solid-js";

export type Props = {
  url: { url: string; type: "image" | "pdf" | "link" };
  onExit: () => void;
};
export function URLViewer(props: Props) {
  onMount(() => {
    fetch(props.url?.url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("couldn't fetch url");
        }
        console.log("the res is :: ", res);
      })
      .catch((err) => {
        console.error("fetching error \n", err);
      });
  });
  return (
    <div class="grid grid-rows-[6%_1fr] w-full h-full gap1">
      <div class="flex flex-row w-full h-fit justify-between">
        {/* <span class=" text-1.2rem font-bold whitespace-nowrap">Preview</span> */}
        <button class="form-btn !w-fit !h-35px <sm:(!w-full)" onClick={(e) => props.onExit()}>
          Go Back
        </button>
        <a class="flex w-fit h-fit  " href={props?.url?.url} target="_blank">
          <i class="i-akar-icons:link-out w-24px h-24px text-brand" />
        </a>
      </div>
      <div class="flex w-full min-h-full">
        <Switch>
          <Match when={props.url?.type === "pdf"}>
            <embed
              class="flex flex-col w-full h-full"
              // src={"https://drive.google.com/viewerng/viewer?embedded=true&url=" + String(props.url?.url)}
              // src={`${String(props.url?.url ?? "")}`}
              src={`https://docs.google.com/viewer?url=${String(props.url?.url ?? "")}&embedded=true`}
              type="application/pdf"
              title="PDF File"
              style="border:0;"
              aria-hidden="false"
              tabindex="0"
            ></embed>
          </Match>
          <Match when={props.url?.type === "image"}>
            <img class="w-full h-full" src={props.url?.url} alt="project.image" />
          </Match>
          <Match when={true}>
            {!props?.url?.url.includes("embed") ? (
              <div>this link cannot be embeded</div>
            ) : (
              <iframe
                class="flex flex-col w-full h-full"
                src={props.url?.url}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            )}
          </Match>
        </Switch>
      </div>
    </div>
  );
}
